import { render, staticRenderFns } from "./commissionRecord.vue?vue&type=template&id=ead21a12&"
import script from "./commissionRecord.vue?vue&type=script&lang=js&"
export * from "./commissionRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports